const firstDepositBannerQueryFilter = {
  section: 'first-deposit',
  handle: 'first-deposit-banner',
};

export default firstDepositBannerQueryFilter;
